module.exports = __webpack_public_path__ + "img/5.f13c5d98.png";